if (typeof AaFaq === "undefined") {
  var AaFaq = true;
  (() => {
    const open = (item) => {
      const question = item.querySelector(".faq-question");
      const toggle = item.querySelector(".faq-toggle");
      const accordion = item.querySelector(".faq-accordion");
      const hasPlusMinusIcon = item.getAttribute("data-icon-type") === "plus_minus";
      accordion.style.height = `${accordion.scrollHeight}px`;
      question.parentNode.classList.add("open");
      if (hasPlusMinusIcon) toggle.textContent = "-";
    };

    const close = (item) => {
      const question = item.querySelector(".faq-question");
      const toggle = item.querySelector(".faq-toggle");
      const accordion = item.querySelector(".faq-accordion");
      const hasPlusMinusIcon = item.getAttribute("data-icon-type") === "plus_minus";
      accordion.style.height = "0px";
      question.parentNode.classList.remove("open");
      if (hasPlusMinusIcon) toggle.textContent = "+";
    };

    const faqItems = document.querySelectorAll(".faq-item");
    faqItems.forEach((item) => {
      const isInitiallyOpen = item.classList.contains("open");
      if (isInitiallyOpen) open(item);
      item.addEventListener("click", () => {
        if (item.classList.contains("open")) {
          close(item);
        } else {
          open(item);
        }
      });
    });
  })();
}
